module.exports = __webpack_public_path__ + "media/9.38b6dbd2.mp3";